class AuditoriaTributariaNcmService extends EficienciaFiscalAbstractService

  configure: (config, injector) ->
    config.url = '/eficiencia-fiscal/auditoria-tributaria-ncm/'

    super(config, injector)

angular.module('eficienciaFiscalModule').service('auditoriaTributariaNcmService', AuditoriaTributariaNcmService)
